export default __webpack_public_path__ + "static/media/background-plant5.5692b317.png";